function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 !important;\n\n  ", " {\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: 2.5rem;\n    align-items: center;\n\n    &::after {\n      display: none;\n    }\n\n    &::before {\n      content: '';\n      display: block;\n      margin-right: 1.625rem;\n      background-image: url(", ");\n      transform-origin: center;\n      height: 1.125rem;\n      width: 1.125rem;\n      transform: rotateZ(90deg);\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  background-color: ", ";\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  transition: transform 0.3s;\n  transform-origin: left center;\n\n  &.subMenu-enter,\n  &.subMenu-exit.subMenu-exit-active {\n    transform: translateX(-100%);\n  }\n\n  &.subMenu-enter.subMenu-enter-active,\n  &.subMenu-exit {\n    transform: translateX(0);\n  }\n\n  ", " {\n    display: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled, { from } from "../../../../theme";
import { HeaderNavButton, HeaderNavLink, HeaderNavWrapper } from "../HeaderNav.styles";
export var HeaderSubNavWrapper = styled.div(_templateObject(), function (props) {
  return props.theme.variables.colors.white;
}, from('lg'));
export var HeaderSubNavList = styled(HeaderNavWrapper)(_templateObject2());
export var HeaderSubNavLink = styled(HeaderNavLink)(_templateObject3());
export var HeaderSubNavBackButton = styled(HeaderNavButton)(_templateObject4());
export var BackListItem = styled.li(_templateObject5(), HeaderSubNavBackButton, function (props) {
  return props.theme.variables.fonts.size.smaller0;
}, function (props) {
  return props.theme.variables.fonts.weight.light;
}, function (props) {
  return props.theme.variables.icons.svg.chevronM;
});